<template>
  <div class="demo-login-container" v-if="visible">
    <a-popover title="点击切换商家" placement="left">
      <template slot="content">
        <div class="btn-container">
          <a-button v-if="showPop" @click="mockLogin(1)">POP商家</a-button>
          <a-button v-if="showPartner" @click="mockLogin(3)">自营供应商</a-button>
          <a-button v-if="showBrand" @click="mockLogin(2)">品牌商</a-button>
        </div>
      </template>
      <a-button type="primary">切换商家</a-button>
    </a-popover>
  </div>
</template>
<script>
  import { Button, Popover } from 'ant-design-vue'
  import { $http } from '@/utils/http'
  import { setCookies, clearCookies } from '@/utils/utils'
  import host from '@/utils/host'
  const isBeta = process.env.VUE_APP_SEVERENV === 'BETA'
  const POPID = isBeta ? 72 : 1688
  const PARTNERID = isBeta ? 8 : 5283
  const BRANDID = isBeta ? 11565 : 35997
  const MOCK_ID = [POPID, PARTNERID, BRANDID]
  export default {
    name: 'demo-login',
    components: {
      [Button.name]: Button,
      [Popover.name]: Popover,
    },
    data() {
      return {
        visible: false,
        showPop: false,
        showPartner: false,
        showBrand: false
      }
    },
    methods: {
      async mockLogin(mockBindType) {
        const res = await $http.get(`${host.portal}/portal-api/account/mockUserAccountSwitch.do?mockBindType=${mockBindType}`)
        if (res && +res.code === 1 && res.data) {
          clearCookies()
          this.setCookieItem(res.data)
          window.location.reload()
        }
      },
      setCookieItem(v) {
        const { buzzCode, buzzId, buzzType, platformNum, id, parentBuzzId, userId } = v
        let _cookie = { ...v.cookies, buzzCode, buzzId, buzzType, platformNum, id, parentBuzzId, userId }
        for(let item in _cookie) {
          setCookies(item, _cookie[item] || '', 24, '.haiziwang.com')
        }
      },
    },
    mounted() {
      const buzzId = +(this.$cookie.get('buzzId') || '')
      const loginSourceCode	= this.$cookie.get('loginSourceCode') || ''
      this.visible = MOCK_ID.includes(buzzId) && loginSourceCode === 'mockLogin'
      this.showPop = buzzId !== POPID
      this.showPartner = buzzId !== PARTNERID
      this.showBrand = buzzId !== BRANDID
    }
  }
</script>
<style lang="scss" scoped>
  .demo-login-container {
    position: fixed;
    top: 20%;
    right: 30px;
    /* 低于遮罩层 */
    z-index: 800;
  }
  .btn-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    button {
      width: 140px;
      &:not(:last-child) {
        margin-bottom: 10px;
      }
    }
  }
</style>
